export const partnerIntegrationNotificationTimeout = 5000;
